module.exports = __webpack_public_path__ + "img/r_training_images_01.5c0ff730.png";